import React from 'react'
import { Outlet } from 'react-router-dom';

const ScheduleMngPage = () => {
  return <Outlet/>
}

export default ScheduleMngPage